import EntitiesListContainer from './entities_list_container';
import EntitiesListView from './entities_list_view';

const EntitiesList = EntitiesListContainer;

export const { initialSortCreated } = EntitiesListView;
export const { initialSortUpdated } = EntitiesListView;

export default EntitiesList;
